<script>
import ModuleTitle from "../common/ModuleTitle.vue";

import { parseTime } from "@/utils/common";
import { getSubPage } from "@/api/pageData";

export default {
  name: "DialogId4",
  components: { ModuleTitle },
  props: {
    currentModule: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      path: this.$route.path,
      pageData: [],
      nowYear: "",
    };
  },
  created() {
    this.initPageData();
  },
  mounted() {
    const now = new Date();
    this.nowYear = parseTime(now, "{y}");
  },
  methods: {
    initPageData() {
      const params = {
        titleid: Number(this.currentModule.titleid),
        title: this.currentModule.title,
        subtitle: "",
        userid: localStorage.getItem("screenUserid") || 0,
        village: localStorage.getItem("currentCommunity") || "",
      };
      getSubPage(params).then((res) => {
        if (res.code === 0) {
          this.pageData = res.msg[0].list;
        }
      });
    },
  },
};
</script>

<template>
  <div class="dialog-id-4">
    <div class="title-container">
      <module-title :title="currentModule.title" :margi-bottom="40" />
    </div>
    <div class="dialog-container">
      <el-image
        class="line"
        :src="require('imgs/modules/dialog-modules/id-4-line.png')"
        alt="line"
      />
      <div class="group-container">
        <div class="item title-box">
          <p>序号</p>
          <p class="title">{{ nowYear }}年民生实事</p>
          <p>负责人</p>
          <p>完成时限</p>
        </div>
        <div v-for="(v, i) in pageData" :key="`dialog-id8-${i}`" class="item">
          <p class="item-order">{{ i + 1 }}</p>
          <p class="item-title">{{ v.headline }}</p>
          <p class="item-name">{{ v.name }}</p>
          <p class="item-time">{{ v.time | formatDate("yyyy-MM-dd") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
// 1330
.dialog-id-4 {
  display: flex;
  flex-direction: column;
  align-items: center;
  .title-container {
    width: 100%;
    display: flex;
    justify-content: flex-start;
  }
  .dialog-container {
    width: 957px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .line {
      width: 957px;
      height: 25px;
    }
  }
}
.group-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 20px;
  width: 913px;
  background-color: #fafafa;
  padding: 14px 22px 30px;
  box-sizing: border-box;
  height: 570px;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    // chrome/safari
    display: none;
  }
  scrollbar-width: none; // firefox
  -ms-overflow-style: none; // IE10+
  .item {
    width: 770px;
    height: auto;
    background-color: #fff;
    box-shadow: 0 3px 10px 0 rgba(7, 60, 0, 0.05);
    display: grid;
    grid-template-columns: 40px 1fr 180px 100px;
    column-gap: 10px;
    padding: 10px 20px;
    box-sizing: border-box;
    text-align: center;
    align-items: center;
    > p {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 35px;
    }
    .item-title {
      text-align: left;
      justify-content: flex-start;
    }
    .item-title,
    .item-name,
    .item-time {
      width: 100%;
      font-size: 14px;
      font-weight: 600;
      color: #000;
      line-height: 18px;
    }
    .item-order {
      font-size: 13px;
      font-weight: 800;
      color: #60b642;
    }
  }
  .title-box {
    font-size: 13px;
    font-weight: 600;
    color: var(--grey-text-color);
    background-color: #fafafa;
    box-shadow: none;
    min-height: 40px;
    .title {
      text-align: center;
    }
  }
}
</style>
